<template>
  <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4">
    <div class="flex-1 px-4">Name</div>
    <div class="w-48 px-4">Email</div>
    <div class="w-32 px-4">Status</div>
    <div class="w-12 mr-2" />
  </div>
</template>

<script>
export default {
  name: 'VListHeader',
};
</script>
